import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { AccountUserService } from 'src/app/services/account-user.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DateFormatPipe } from 'src/app/pipes/dateFormat.pipe';
@Component({
  selector: 'app-payment-stat',
  templateUrl: './payment-stat.component.html',
  styleUrls: ['./payment-stat.component.css']
})
export class PaymentStatComponent implements OnInit {
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  filterParams: string;
  DateCatogory = 'TODAY';
  DateCatogoryfee = 'TODAY';
  account = false;
  account_fee = 'true';
  public userForm: UntypedFormGroup;
  appt: any;
  appointment: any;
  token: any;
  order;
  donation;
  datege;
  statType: string;
  StatDateType: string;
  datas: Object;
  salesChannel: any;
  filtervalue: any;
  account_value;
  showlist;
  day_value;
  enddate;
  startdate;
  GoSPlistAppt;
  GoSPlistApptFor;
  GoSPlistApptDue;
  day_select: string;
  showdatedata;
  account_select;
  hideName = false;
  hideDate = false;
  hidetype = false;
  scConfig: any = {};
  datePipe = new DatePipe('en-US');
  datele;
  dayTypes: any = [];
  paymentOn: any;
  paymentOn_ge: any;
  paymentOn_le: any;
  daydata;
  fildata;
  isNotdaterange = false;
  tableFilters: any = '';
  accdata;
  startpicker;
  endpicker;
  selectedFilter: string;
  api_error: any;
  api_error1: any;
  api_success: any;
  today = new Date();
  showchecked;
  showcheckedfee;
  accountid;
  subDomains: any = [];
  filterParamCustomer: string;
  serviceSectors: any;
  domain: any;
  domainModel = 0;
  todayDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  Type = 'All';
  store_filterValue: any;
  teleservice: boolean;
  tele_value;
  mode_value: any;
  isShowTknAppt: boolean = true;
  online: any;
  walkin: any;
  phonein: any;
  newlysignedfilterParam = '';
  payment: any;
  billPayment: any;
  donationPayment: any;
  prePayment: any;
  totalPaid: any;
  totalRefunded: any;
  showPaidData: boolean;
  accountId: any;
  account_id: any;
  showaccId= false;
  hideaccId= true;
  amt: any;
  datele_fee: string;
  datege_fee: string;
  userAgents: any;
  useragent;
  userAgent = [];
  paymentLink;
  paymentUid;
  api_err: string;
  apisucces: string;
  constructor(private router: Router, private route: ActivatedRoute, private commonService: CommonfilterService, private activatedRoute: ActivatedRoute, private commonfilterService: CommonfilterService, public dateformat: DateFormatPipe, private formBuilder: UntypedFormBuilder, private commonservice: CommonfilterService, private commonFilter: CommonfilterService, private accountuserService: AccountUserService,) {
    this.commonfilterService.getConfigData()
      .subscribe(res => {
        this.scConfig = res;
        this.dayTypes = this.scConfig.pastStatDateCategoryDetails;
        this.userAgents = this.scConfig.userAgentType;
      });
    this.commonService.getServiceSectors()
      .subscribe(res => {
        this.serviceSectors = res;
      });
  }
  ngOnInit() {
    this.getBooking();
    this.getJaldeeFee();
    this.showchecked = false;
    this.showcheckedfee = true;
    this.activatedRoute.queryParams.subscribe(params => {
      this.daydata = params.dateCatogory;
      this.fildata = params.filterApplied;
      this.startpicker = params.startDate;
      this.endpicker = params.endDate;
      this.accdata = params.isIncludeTest;
      this.accountId = params.accountId;
    });
    this.account_id = this.accountId;
    // if (this.daydata && this.fildata) {
    //   let newlyfilterParam = '';
    //   newlyfilterParam = this.daydata + '/withTest' + '/' + this.accdata + '/stats' + '?' + this.fildata;;
    //   this.getBooking1(newlyfilterParam);
    // }
    if (this.accdata == 'true') {
      this.showchecked = true;
    }
    if (this.accdata == 'false') {
      this.showchecked = false;
    }
  }
  detectPaymentchange(){
    this.api_err = '';
    this.apisucces = '';
    if(!this.paymentUid){
      this.api_err = 'Please enter paymentuid';
      setTimeout(()=>{
        this.api_err = '';
   }, 3000);
      return;
    }
    this.accountuserService.updatePaymentwithUid(this.paymentUid).subscribe(
      (data) => {
        this.apisucces = 'Payment with '+this.paymentUid+' updated';
        setTimeout(()=>{
          this.apisucces = '';
     }, 3000);
     this.paymentUid = '';
      },
      (error) => {
        this.api_err = error.error;
        setTimeout(()=>{
          this.api_err = '';
     }, 3000);
      });
  }
  onChange(event) {
    if (event.target.value === 'DATE_RANGE') {
      this.showaccId =  true;
      this.hideaccId= false;
      this.hideName = true;
      this.isNotdaterange = true
    }
    else {
      this.showaccId =  false;
      this.hideaccId= true;
      this.hideName = false;
      this.isNotdaterange = false;
    }
  }
  onChangeDate(event) {
    if (event.target.value === 'DATE_RANGE') {
      this.hideDate = true;
    }
    else {
      this.hideDate = false;
    }
  }
  onChangeLink(event) {
    this.paymentLink = event.target.value;
  }
  getUserAgent(agent) {
    this.userAgent.push(agent.value)
    console.log(this.userAgent)
    // this.useragent = event.target.value;
  }
  // getBooking1(newlyfilterParam) {
  //   this.api_error = '';
  //   this.api_success = '';
  //   this.accountuserService.getStat(newlyfilterParam).subscribe(
  //     (data) => {
  //       this.apptcreatedOn = data.apptCreatedOn;
  //       this.apptcreatedFor = data.apptCreatedFor;
  //       this.apptcreatedDue = data.apptBookingDueCreatedFor;
  //       this.tokencreatedOn = data.checkinCreatedOn;
  //       this.tokencreatedFor = data.checkinCreatedFor;
  //       this.tokencreatedDue = data.checkinBookingDueCreatedFor;
  //       this.donationCreatedOn = data.donCreatedOn;
  //       this.prepaymentCreatedOn = data.prepaymentCreatedOn;
  //     },
  //     (error) => {
  //       this.api_error = error.error;
  //     });
  // }
  getBooking() {
    this.account_value = this.account;
    this.day_value = this.DateCatogory;
    this.startdate = this.datege;
    this.enddate = this.datele;
    this.tele_value = this.teleservice;
    if (this.teleservice === undefined) {
      this.tele_value = false;
    }

    this.tableFilters = this.commonService.filterParams_without_operators('bookingStat');
    this.store_filterValue = this.tableFilters;
    if (this.DateCatogory === 'DATE_RANGE') {
      if (this.teleservice) {
        this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/payment/stats' + '?' + 'date-le=' + this.datele + '&date-ge=' + this.datege + '&' + 'tele_service=' + this.teleservice + '&';
        this.selectMode();
      } else {
        this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/payment/stats' + '?' + 'date-le=' + this.datele + '&date-ge=' + this.datege + '&' ;
        this.selectMode();
      }

    } else {
      if (this.teleservice) {
        this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/payment/stats' + '?' + 'tele_service=' + this.teleservice + '&';
        this.selectMode();
      }

      else {
        this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/payment/stats?' ;
        this.selectMode()
      }
    }
    this.api_error = '';
    this.api_success = '';
    this.accountuserService.getStat(this.newlysignedfilterParam , this.userAgent , this.paymentLink).subscribe(
      (data) => {
        this.appointment = data.appiontment;
        this.token = data.checkin;
        this.order = data.order;
        this.donation = data.donation;
        this.payment = data.total;
        this.billPayment = data.billPayment;
        this.donationPayment = data.donationPayment;
        this.prePayment = data.prePayment;
        this.totalPaid = data.totalPaid;
        this.totalRefunded = data.totalRefunded;
      },
      (error) => {
        this.api_error = error.error;
        console.log(this.api_error)
      });
  }
  getJaldeeFee(){
    this.tableFilters = this.commonService.filterParams_without_operators('jaldeefee');
    if (this.DateCatogoryfee === 'DATE_RANGE') {
      if (this.teleservice) {
        this.newlysignedfilterParam = this.DateCatogoryfee + '/withTest' + '/' + this.account_fee + '/jaldeeFees' + '?' + 'date-le=' + this.datele_fee + '&date-ge=' + this.datege_fee + '&' + 'tele_service=' + this.teleservice + '&';
        this.selectMode();
      } else {
        this.newlysignedfilterParam = this.DateCatogoryfee + '/withTest' + '/' + this.account_fee + '/jaldeeFees' + '?' + 'date-le=' + this.datele_fee + '&date-ge=' + this.datege_fee + '&' ;
        this.selectMode();
      }

    } else {
      if (this.teleservice) {
        this.newlysignedfilterParam = this.DateCatogoryfee + '/withTest' + '/' + this.account_fee + '/jaldeeFees' + '?' + 'tele_service=' + this.teleservice + '&';
        this.selectMode();
      }

      else {
        this.newlysignedfilterParam = this.DateCatogoryfee + '/withTest' + '/' + this.account_fee + '/jaldeeFees?' ;
        this.selectMode()
      }
    }
    this.api_error1 = '';
    this.api_success = '';
    this.accountuserService.getFee(this.newlysignedfilterParam).subscribe(
      (data) => {
        this.amt = data.amt;
      },
      (error) => {
        this.api_error1 = error.error;
        console.log(this.api_error1)
      });
  }
  selectMode() {
    if (this.online && !this.walkin && !this.phonein) {
      this.changeMode('online')
    }
    else if (!this.online && this.walkin && !this.phonein) {
      this.changeMode('walkin')
    }
    else if (!this.online && !this.walkin && this.phonein) {
      this.changeMode('phonein')
    }
    else if (this.online && this.walkin && !this.phonein) {
      this.changeMode('online,walkin')
    }
    else if (!this.online && this.walkin && this.phonein) {
      this.changeMode('walkin,phonein')
    }
    else if (this.online && !this.walkin && this.phonein) {
      this.changeMode('online,phonein')
    }
    else if (this.online && this.phonein && this.walkin) {
      this.changeMode('online,walkin,phonein')
    }
    else {
      this.changeMode('default')
    }
  }
  changeMode(mode) {
    this.mode_value = mode;
    switch (mode) {
      case 'online':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'online' + '&' + this.tableFilters
        // this.newlysignedfilterParam = this.DateCatogory + '/withTest' + '/' + this.account + '/stats' + '?' + 'booking_mode=' + 'online' + '&' + this.tableFilters; 
        break;
      case 'walkin':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'walkin' + '&' + this.tableFilters;
        break;

      case 'phonein':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'phonein' + '&' + this.tableFilters;
        break;
      case 'online,walkin':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'online,walkin' + '&' + this.tableFilters;
        break;
      case 'walkin,phonein':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'walkin,phonein' + '&' + this.tableFilters;
        break;
      case 'online,phonein':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'online,phonein' + '&' + this.tableFilters;
        break;
      case 'online,walkin,phonein':
        this.newlysignedfilterParam = this.newlysignedfilterParam + 'booking_mode=' + 'online,walkin,phonein' + '&' + this.tableFilters;
        break;
      default:
        this.newlysignedfilterParam = this.newlysignedfilterParam+this.tableFilters;
    }

  }
  showPaidDetails(){
    this.showPaidData = true;
  }
  onDomainChange(event) {
    this.subDomains = [];
    for (let i = 0; i < this.serviceSectors.length; i++) {
      if (event.target.value == this.serviceSectors[i].id) {
        this.domain = this.serviceSectors[i].domain;
        for (let j = 0; j < this.serviceSectors[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.serviceSectors[i].subDomains[j].displayName,
            'id': this.serviceSectors[i].subDomains[j].id, 'subDomain': this.serviceSectors[i].subDomains[j].subDomain
          });
        }
      }
    }
  }
  ontypeChange(event) {
    if (event.target.value === 'token_appt') {
      this.hidetype = true;
      this.isShowTknAppt = false;
    }
    else if (event.target.value === 'All') {
      this.online = '';
      this.walkin = '';
      this.phonein = '';
      this.hidetype = false;
      this.isShowTknAppt = true;
    }
  }
}